


import React, { useState } from "react";
import sad from "../../../assets/images/NewActivityImages/sad.jpg";
import happy from "../../../assets/images/NewActivityImages/happy.jpg";
import bird from "../../../assets/images/NewActivityImages/bird.jpg";


export default function BubbleSortQuiz2() {
  const correct = {
    1: "b",
    2: "b",
    3: "a",
    4: "b",
    5: "a",
    6: "a",
    7: "a",
    8: "a",
    9: "a",
    10: "a",
  };

  const [current, setCurrent] = useState(1);
  const [results, setResults] = useState({});
  
  const [character, setCharacter] = useState(
    bird
  );

  
  const questions = [
  {
    question: "If a computer uses Linear Search to find the number 8 in [3, 5, 8, 2], how many checks does it make?",
    options: ["1", "2", "3", "4"],
    answer: 2 // 3rd item
  },
  {
    question: "In Linear Search, what happens if the item is not found?",
    options: ["The computer keeps searching forever", "It gives up and says 'not found'", "It crashes", "It starts from the end again"],
    answer: 1
  },
  {
    question: "Which of these lists would make Linear Search take the most time?",
    options: [
      "A list where the item is at the start",
      "A list where the item is at the end",
      "A list with only one item",
      "An empty list"
    ],
    answer: 1
  },
  {
    question: "If we are looking for 'banana' in ['apple', 'grape', 'banana', 'orange'], which items does Linear Search check?",
    options: [
      "Only 'banana'",
      "'apple', 'grape', 'banana'",
      "'banana', 'orange'",
      "None"
    ],
    answer: 1
  },
  {
    question: "If we double the size of a list, what usually happens to Linear Search time?",
    options: ["It stays the same", "It gets a little faster", "It takes about twice as long", "It stops working"],
    answer: 2
  },
  {
    question: "Why might someone still use Linear Search even if it’s slow?",
    options: [
      "Because it is easy and works on any list",
      "Because it looks cool",
      "Because it skips numbers",
      "Because computers like it"
    ],
    answer: 0
  },
  {
    question: "Which of these is not a good time to use Linear Search?",
    options: [
      "When the list is small",
      "When the list is huge and sorted",
      "When the list has only a few items",
      "When we don’t know if the list is sorted"
    ],
    answer: 1
  },
  {
    question: "If you are using Linear Search to find your friend's name in your class list, where should you start?",
    options: ["At the end", "In the middle", "At the start", "Skip some names"],
    answer: 2
  },
  {
    question: "What will happen if the list has two of the same item and we search using Linear Search?",
    options: [
      "It finds only the first one",
      "It finds both at once",
      "It finds the last one only",
      "It gets confused and stops"
    ],
    answer: 0
  },
  {
    question: "If Linear Search checks every item one by one, what is the worst case?",
    options: [
      "The item is first",
      "The item is missing or last",
      "The item is in the middle",
      "It finds it before searching"
    ],
    answer: 1
  }
];

  const handleAnswer = (qIndex, ans) => {
    if (ans === correct[qIndex + 1]) {
      setResults((prev) => ({ ...prev, [qIndex + 1]: "✅ Correct!" }));
      setCharacter(happy);
      setTimeout(() => {
        setCurrent((prev) => prev + 1);
        setCharacter(bird)
      }, 1200);
    } else {
      setResults((prev) => ({ ...prev, [qIndex + 1]: "❌ Try again!" }));
      setCharacter(sad);
    }
  };

  return (
    <div
      style={{
        fontFamily: "'Comic Neue', cursive",
        background: "linear-gradient(135deg,rgb(255, 255, 255), #ffffff)",
        textAlign: "center",
        color: "#333",
        padding: "30px",
        overflowX: "hidden",
        position: "relative",
        minHeight: "100vh",
      }}
    >
      <h1
        style={{
          color: "#ff6f61",
          textShadow: "2px 2px #fff",
          fontSize: "2.5em",
        }}
      >
        Bubble Sort Adventure Quiz!
      </h1>
      <p>Answer one question at a time to move forward in the Bubble Sort journey!</p>

      <img
        src={character}
        alt="Cartoon"
        style={{
          position: "fixed",
          bottom: "10px",
          left: "10px",
          width: "120px",
          transition: "all 0.5s ease",
        }}
      />

      {questions.map((q, i) =>
        current === i + 1 ? (
          <div
            key={i}
            style={{
              background:  "linear-gradient(135deg,rgb(126, 153, 230),rgb(142, 181, 231))",
              margin: "20px auto",
              padding: "25px",
              borderRadius: "20px",
              width: "80%",
              boxShadow: "0 6px 25px rgba(0,0,0,0.15)",
            }}
          >
            <h3>
              {i + 1}️⃣ {q.q}
            </h3>
            {q.options.map((opt, idx) => (

              
              <button
                key={idx}
                style={{
                  background: "linear-gradient(45deg, #f6d365, #fda085)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "12px",
                  padding: "12px 25px",
                  cursor: "pointer",
                  margin: "8px",
                  fontSize: "1em",
                }}
                onClick={() => handleAnswer(i, String.fromCharCode(97 + idx))}
              >
                {String.fromCharCode(65 + idx)}. {opt}
              </button>
            ))}
            <div
              style={{
                fontWeight: "bold",
                marginTop: "15px",
                fontSize: "1.2em",
                color: results[i + 1]?.includes("✅") ? "green" : "red",
              }}
            >
              {results[i + 1]}
            </div>
          </div>
        ) : null
      )}

      {current > questions.length && (
        <h2 style={{ color: "#00897b" }}>
          🎉 Amazing! You finished the Bubble Sort Quiz!
        </h2>
      )}
    </div>
  );
}
